import { FlowStandardAnalyticEventStatus } from 'flow-schema';
import { z } from 'zod';

export {
  type FlowStandardAnalyticEventCreateBody,
  type FlowStandardAnalyticEventCreateBodyInput,
  FlowStandardAnalyticEventCreateBodySchema,
  type FlowStandardAnalyticEventListQuery,
  FlowStandardAnalyticEventListQuerySchema,
  FlowStandardAnalyticEventStatus,
  type FlowStandardAnalyticEventUpdateBody,
  FlowStandardAnalyticEventUpdateBodySchema,
} from 'flow-schema';

export const StandardAnalyticEventSchema = z.object({
  id: z.uuid(),
  created: z.string().date(),
  updated: z.string().date(),
  name: z.string(),
  description: z.string(),
  categoryId: z.uuid(),
  customAttributeKeys: z.array(z.string()),
  status: z.enum(FlowStandardAnalyticEventStatus),
  categoryName: z.string().optional(),
});

export type StandardAnalyticEvent = z.infer<typeof StandardAnalyticEventSchema>;
